import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import NumberFormat from "react-number-format";

import { formatPrice, formatTitleInUrl, CarTransmission, stypes, renderNumberGreaterThan100 } from "../common/common";

import FavoriteButton from "./favoritebutton";

import car_photo from "../../static/images/upload/car_1.png";
import avatar_default from "../../static/images/avatar_default.png";
import {
	IcStarRating,
	IcTotalTrip,
	IcAddrCar,
	IcInstant,
	IcIns,
	IcNonMortgageGreen,
	IcChevrDown,
	IcInvalid,
} from "./svg";
import { connect } from "react-redux";

//-- CarItems Props

//-- isNewTab: open car detail popup (true)
//-- togglePopup (function): must be when isNewTab
//-- avatar: show avatar owner
//-- fav: show fav button
//-- Note: fav must be add showLoginForm && isLogged (true)
// -- nonLoginProfile: check logged in or not
// -- multiPhotos: img slide in car item or not
// -- totalTripsFull: view >100 or 100+ (true in account page)

const CarItem = ({
	stype,
	car,
	isAirDelivery,
	togglePopup,
	avatar,
	isNewTab,
	relatedCar,
	showLoginForm,
	isLogged,
	fav,
	openNewWindow,
	nonLoginProfile,
	multiPhotos,
	totalTripsFull,
	appInit,
}) => {
	const isSD = stype === stypes.SD;
	const priceMode = appInit?.data?.priceMode;
	const hiddenFeeMode = priceMode === 2;
	const [showAvail, setShowAvail] = useState(false);
	const [swiperCar, setSwiperCar] = useState(undefined);

	return (
		<a
			href={`/car/${isSD ? "" : "wd/"}${formatTitleInUrl(car.name)}/${car.id}`}
			target={openNewWindow ? "_blank" : null}
			onClick={(e) => {
				if (isNewTab) {
					e.preventDefault();
					return false;
				}
			}}
			className={`${relatedCar ? "" : "item"} item-car`}>
			<div className="item-box">
				<div className="img-car">
					{multiPhotos ? (
						<div className="wrap-swiper">
							<Swiper
								className="swiper-item-car"
								slidesPerView={1}
								modules={[Navigation, Pagination]}
								pagination={{
									el: ".pagi-item-car",
									clickable: true,
									dynamicBullets: true,
								}}
								onSwiper={(swiper) => {
									setSwiperCar(swiper);
								}}

								// navigation={{
								// 	nextEl: `.item-car-next-${car.id}`,
								// 	prevEl: `.item-car-prev-${car.id}`,

								// }}
							>
								{car.photos?.length ? (
									car.photos.map((photo) => (
										<SwiperSlide key={photo.id}>
											<div
												className="fix-img"
												onClick={(e) => {
													let isUpdate = relatedCar ? true : false;
													if (isNewTab) {
														togglePopup(car, isUpdate);
													}
												}}>
												<img loading="lazy" src={photo.thumbUrl} />
											</div>
										</SwiperSlide>
									))
								) : (
									<SwiperSlide>
										<div
											className="fix-img"
											onClick={(e) => {
												let isUpdate = relatedCar ? true : false;
												if (isNewTab) {
													togglePopup(car, isUpdate);
												}
											}}>
											<img loading="lazy" src={car_photo} />
										</div>
									</SwiperSlide>
								)}
								<div className="swiper-pagination pagi-item-car" />
							</Swiper>
							{/* <div className={`swiper-button-prev item-car-prev-${car.id}`} onClick={prevSlide}/>
							<div className={`swiper-button-next item-car-next-${car.id}`} onClick={nextSlide}/> */}
						</div>
					) : (
						<div
							className="fix-img"
							onClick={(e) => {
								let isUpdate = relatedCar ? true : false;
								if (isNewTab) {
									togglePopup(car, isUpdate);
								}
							}}>
							<img loading="lazy" src={`${car.photos?.length ? car.photos[0].thumbUrl : car_photo}`} />
						</div>
					)}

					{fav ? (
						<FavoriteButton icon={true} car={car} showLoginForm={showLoginForm} isLogged={isLogged} stype={stype} />
					) : null}
					<span className="label-pos">
						{isSD ? (
							<>
								{car.instant > 0 && (
									<span className="rent">
										Đặt xe nhanh <IcInstant />
									</span>
								)}
								{car.nonMortgage > 0 && (
									<span className="rent">
										Miễn thế chấp <IcNonMortgageGreen />
									</span>
								)}
							</>
						) : (
							<>
								{car.wdShort && car.wdShort.instant === 1 && (
									<span className="rent">
										Đặt xe nhanh <IcInstant />
									</span>
								)}
							</>
						)}
					</span>
					{avatar ? (
						<div className={`avatar avatar--s ${car.ownerHostFiveStar > 0 ? "has-five-star" : ""}`}>
							<img loading="lazy" src={car.ownerAvatar && car.ownerAvatar !== "" ? car.ownerAvatar : avatar_default} />
						</div>
					) : null}

					{isSD
						? car.totalDiscountPercent > 0 && (
								<span className="discount">
									Giảm {car.totalDiscountPercent}%{nonLoginProfile ? " - Chuyến đầu" : ""}
								</span>
						  )
						: car.wdShort &&
						  car.wdShort.totalDiscountPercent > 0 && (
								<span className="discount">
									Giảm {car.wdShort.totalDiscountPercent}%{nonLoginProfile ? " - Chuyến đầu" : ""}
								</span>
						  )}
				</div>
				<div
					className="desc-car"
					onClick={(e) => {
						let isUpdate = relatedCar ? true : false;
						if (isNewTab) {
							togglePopup(car, isUpdate);
						}
					}}>
					<div className="desc-tag">
						<span className={`tag-item ${car.optionsTransmission === 1 ? "transmission" : "delivery"}`}>
							{CarTransmission[car.optionsTransmission]}
						</span>
						{isSD ? (
							<>
								{car.deliveryEnable === 1 && car.deliveryPrice > 0 && !isAirDelivery && (
									<span className="tag-item non-mortgage">Giao xe tận nơi</span>
								)}
								{car.deliveryEnable === 1 && car.deliveryPrice === 0 && !isAirDelivery && (
									<span className="tag-item non-mortgage">Miễn phí giao xe</span>
								)}
								{car.deliveryEnable === 1 && car.deliveryFee > -1 && isAirDelivery && (
									<>
										{car.deliveryFee > 0 ? (
											<span className="tag-item non-mortgage">
												Giao nhận sân bay
												<span className="dot">•</span>
												{`+ ${formatPrice(car.deliveryFee)}`}
											</span>
										) : (
											<span className="tag-item non-mortgage">Miễn phí giao nhận</span>
										)}
									</>
								)}
							</>
						) : (
							<>
								{car.wdShort && car.wdShort.deliveryEnable === 1 && car.wdShort.deliveryFee > -1 && isAirDelivery && (
									<>
										{car.wdShort.deliveryFee > 0 ? (
											<span className="tag-item non-mortgage">
												Đưa đón sân bay
												<span className="dot">•</span>+{formatPrice(car.wdShort.deliveryFee)}
											</span>
										) : (
											<span className="tag-item non-mortgage">Miễn phí đưa đón</span>
										)}
									</>
								)}
							</>
						)}
					</div>
					<div className="desc-name">
						<p>{car.name}</p>
						{/* {car.insSupport === 1 && (
							<div className="wrap-svg">
								<IcIns />
							</div>
						)} */}
					</div>
					<div className="desc-address-price">
						<div className="address">
							<div className="wrap-svg">
								<IcAddrCar />
							</div>
							<p>{car.locationAddrS}</p>
						</div>

						{car.distance && car.distance !== 0 && <p className="distance">~ {car.distance}</p>}
					</div>

					<div className="line-page" />
					<div className="desc-info-price">
						<div className="info">
							{car.totalTrips > 0 ? (
								<>
									{car.rating.avg > 0 ? (
										<>
											<div className="wrap-svg">
												<IcStarRating />
											</div>
											<span className="info">{car.rating.avg.toFixed(1)}</span>
											<span className="dot">•</span>
										</>
									) : null}
									<div className="wrap-svg">
										<IcTotalTrip />
									</div>
									{totalTripsFull ? (
										<span className="info">{car.totalTrips} chuyến</span>
									) : (
										<span className="info">{renderNumberGreaterThan100(car.totalTrips)} chuyến</span>
									)}
								</>
							) : (
								<>
									<span className="info">Chưa có chuyến</span>
								</>
							)}
						</div>
						<div className="wrap-price">
							{isSD ? (
								hiddenFeeMode ? (
									<div className="price">
										{car.priceOriginWithFee !== car.priceWithFee && (
											<span className="price-origin">
												<NumberFormat
													value={formatPrice(car.priceOriginWithFee)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> 
											</span>
										)}
										<span className="price-special">
											<NumberFormat
												value={formatPrice(car.priceWithFee)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
										</span>
										/&nbsp;ngày
									</div>
								) : (
									<div className="price">
										{car.priceOrigin !== car.price && (
											<span className="price-origin">
												<NumberFormat
													value={formatPrice(car.priceOrigin)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> 
											</span>
										)}
										<span className="price-special">
											<NumberFormat
												value={formatPrice(car.price)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
										</span>
										/&nbsp;ngày
									</div>
								)
							) : hiddenFeeMode ? (
								<div className="price">
									{car.wdShort && car.wdShort.priceOriginWithFee !== car.wdShort.priceWithFee && (
										<span className="price-origin">
											<NumberFormat
												value={formatPrice(car.wdShort.priceOriginWithFee)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
											</span>
									)}
									<span className="price-special">
											<NumberFormat
												value={formatPrice(car.wdShort && car.wdShort.priceWithFee)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
										&nbsp;</span>
									/&nbsp;chuyến
								</div>
							) : (
								<div className="price">
									{car.wdShort && car.wdShort.priceOrigin !== car.wdShort.price && (
										<span className="price-origin">
											<NumberFormat
												value={formatPrice(car.wdShort.priceOrigin)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
											</span>
									)}
									<span className="price-special">
											<NumberFormat
												value={formatPrice(car.wdShort && car.wdShort.price)}
												displayType={"text"}
												thousandSeparator={","}
												suffix={"K"}
											/> 
										&nbsp;</span>
									/&nbsp;chuyến
								</div>
							)}

							{isSD
								? car.priceTotal > 0 && (
										<div className="total-price">
											<p>
												Giá tổng 
												<NumberFormat
													value={formatPrice(car.priceTotal)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> 
									
											</p>
										</div>
								  )
								: car.wdShort &&
								  car.wdShort.finalPrice > 0 && (
										<div className="total-price">
											<p>
												Giá tổng 
												<NumberFormat
													value={formatPrice(car.wdShort.finalPrice)}
													displayType={"text"}
													thousandSeparator={","}
													suffix={"K"}
												/> 
											
											</p>
										</div>
								  )}
						</div>
					</div>

					{car.notAvailErrors && car.notAvailErrors[0] !== "" && (
						<>
							<div className="line-page" />
							<div className={`invalid ${car.notAvailErrors.length === 1 || showAvail ? "full" : ""}`}>
								<div className="invalid-list">
									{showAvail ? (
										car.notAvailErrors.map((item, i) => (
											<div className="invalid-list__item" key={i}>
												<p>{item}</p>
											</div>
										))
									) : (
										<div className="invalid-list__item">
											<p>{car.notAvailErrors[0]}</p>
										</div>
									)}
								</div>
								<div
									className="wrap-svg show-more"
									onClick={(e) => {
										setShowAvail(true), e.preventDefault(), e.stopPropagation();
									}}>
									<IcChevrDown />
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</a>
	);
};

function mapState(state) {
	return {
		appInit: state.appInit,
	};
}

export default connect(mapState)(CarItem);
